import { FiArrowDown, FiArrowUp, FiEdit2, FiTrash } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function BabList({
  bab,
  onDelete,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
  hovered,
  onHover,
  onLeave,
}) {
  const link = `/content/bab/${bab.id}`;
  return (
    <div
      className={`flex items-center gap-2 py-2 border-b last:border-b-0 border-white-200 ${
        hovered ? "bg-white-200" : ""
      }`}
      onMouseEnter={() => onHover(bab.id)}
      onMouseLeave={onLeave}
    >
      <div className="font-bold flex-1 p-2">{bab.title}</div>
      <div className="flex items-center flex-wrap gap-2">
        <Link
          to={link}
          className="p-1.5 rounded-sm border border-white-300 text-sm hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 flex items-center mt-1 transition-colors"
        >
          <FiEdit2 />
        </Link>
        <button
          type="button"
          onClick={() => onDelete(bab.id)}
          className="p-1.5 rounded-sm border border-white-300 text-sm hover:bg-red-200 hover:border-red-300 hover:text-white-100 flex items-center mt-1 transition-colors"
        >
          <FiTrash />
        </button>
        <div className="flex mt-1 mr-2">
          <button
            type="button"
            onClick={onMoveUp}
            disabled={isFirst}
            className="p-1.5 rounded-l-sm border border-white-300 text-sm transition-colors hover:bg-yellow-200 hover:border-yellow-300 hover:text-white-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            <FiArrowUp />
          </button>
          <button
            type="button"
            onClick={onMoveDown}
            disabled={isLast}
            className="p-1.5 rounded-r-sm border border-l-0 border-white-300 text-sm transition-colors hover:bg-yellow-200 hover:border-yellow-300 hover:text-white-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            <FiArrowDown />
          </button>
        </div>
      </div>
    </div>
  );
}
